var WDN = WDN || {};

if (typeof WDN.MegaMenu === "undefined") {
  WDN.MegaMenu = (function () {
    var init, createInstances;

    var nodes = {
      triggers: document.querySelectorAll("[data-megamenu-trigger]"),
    };

    var config = {
      animation_delay: 0,
    };

    var MenuTriggers = {};

    var megaMenuIsActive = false;

    var timeouts = {
      linkHover: false,
      linkLeave: false,
      menuHover: false,
      menuLeave: false,
    };

    // Helper for showcase group async
    /*
    var showcaseRenderer = {
      storage: {},
      render: function (id) {
        // Use value from storage
        if (this.storage.hasOwnProperty(id)) {
          return this.storage[id];
        }

        // If no value from storage - fetch everything
        return fetch(Shopify.routes.root + "?section_id=async-megamenu-products")
          .then((res) => {
            return res.text();
          })
          .then((res) => {
            var domParser = new DOMParser();
            var parsedResponse = domParser.parseFromString(res, "text/html");

            // Select all showcase elements (per 1st level link)
            var menuShowcases = parsedResponse.querySelectorAll("[data-showcase-wrapper]");

            // Loop throught them
            menuShowcases.forEach(function (wrapper) {
              // Get wrapper ID (link.handle)
              var wrapperID = wrapper.getAttribute("data-showcase-wrapper");
              // Create blank array where we will output the content
              this.storage[wrapperID] = [];

              // Select all showcases within first level link (eg. beard growth, beard care)
              wrapper.querySelectorAll("[data-showcase-group]").forEach(function (showcase) {
                // Push into main array
                this.storage[wrapperID].push(showcase);
              }, this);
            }, this);
            // Return
            return this.storage[id];
          });
      },
    };*/

    var MenuTrigger = function (element) {
      this.id = element.getAttribute("data-megamenu-trigger");
      this.element = element;
      this.megaMenuGroups = document.querySelectorAll("[data-megamenu-group]");
      this.megaMenuGroup = document.querySelector("[data-megamenu-group='" + this.id + "']");
      //  this.showcaseContainer = this.megaMenuGroup.querySelector("[data-menu-group-showcase]");
      this.init();
    };

    MenuTrigger.prototype.clearActive = function () {
      for (var key in MenuTriggers) {
        if (MenuTriggers.hasOwnProperty(key)) {
          if (MenuTriggers[key].isActive) {
            MenuTriggers[key].setActive(false);
          }
        }
      }
    };

    MenuTrigger.prototype.renderShowcases = async function () {
      return;
      if (this.showcasesRendered) return;

      var showcaseContent = await showcaseRenderer.render(this.id);

      showcaseContent.forEach(function (content) {
        this.showcaseContainer.appendChild(content);
      }, this);

      this.showcasesRendered = true;

      for (var key in WDN.CollectionShowcase.list) {
        if (WDN.CollectionShowcase.list.hasOwnProperty(key)) {
          if (WDN.CollectionShowcase.list[key].megamenu_handle === this.id) {
            WDN.CollectionShowcase.list[key].init();
          }
        }
      }
    };

    // fires when user mouse hovers link
    MenuTrigger.prototype.handleElementMouseEnter = function () {
      if (this.isActive) return;
      var delay = megaMenuIsActive ? 0 : config.animation_delay;

      timeouts.linkHover = setTimeout(
        function () {
          clearTimeout(timeouts.linkLeave);
          clearTimeout(timeouts.menuLeave);
          // this.renderShowcases();
          this.clearActive();
          this.setActive(true);
          this.toggleMenuGroups();
        }.bind(this),
        delay
      );
    };

    // fires when user mouse leaves link
    MenuTrigger.prototype.handleElementMouseLeave = function () {
      clearTimeout(timeouts.linkHover);
      timeouts.linkLeave = setTimeout(
        function () {
          this.setActive(false);
          this.hideMenuGroups();
        }.bind(this),
        config.animation_delay
      );
    };

    // fires when user mouse enters mega menu
    MenuTrigger.prototype.handleMegaMenuMouseEnter = function () {
      clearTimeout(timeouts.linkLeave);
      clearTimeout(timeouts.menuLeave);
    };

    // fires when user mouse leaves mega menu
    MenuTrigger.prototype.handleMegaMenuMouseLeave = function () {
      clearTimeout(timeouts.linkHover);
      timeouts.menuLeave = setTimeout(
        function () {
          this.setActive(false);
          this.hideMenuGroups();
        }.bind(this),
        config.animation_delay
      );
    };

    MenuTrigger.prototype.hideMenuGroups = function () {
      this.megaMenuGroups.forEach(function (group) {
        group.removeAttribute("data-active");
      });
    };

    MenuTrigger.prototype.setActiveMenuGroup = function () {
      this.megaMenuGroup.setAttribute("data-active", "");
    };

    MenuTrigger.prototype.toggleMenuGroups = function () {
      this.hideMenuGroups();
      this.setActiveMenuGroup();
    };

    MenuTrigger.prototype.setActive = function (newState) {
      if (this.isActive === newState) return;
      if (newState) {
        this.element.setAttribute("data-active", "");
      } else {
        this.element.removeAttribute("data-active");
      }

      this.isActive = newState;
      megaMenuIsActive = newState;
      this.toggleMenuGroups();
    };

    MenuTrigger.prototype.bind = function () {
      this.element.addEventListener("mouseenter", this.handleElementMouseEnter.bind(this));
      this.element.addEventListener("mouseleave", this.handleElementMouseLeave.bind(this));
      this.megaMenuGroup.addEventListener("mouseenter", this.handleMegaMenuMouseEnter.bind(this));
      this.megaMenuGroup.addEventListener("mouseleave", this.handleMegaMenuMouseLeave.bind(this));
    };

    MenuTrigger.prototype.init = function () {
      this.bind();
    };

    createInstances = function () {
      nodes.triggers.forEach(function (trigger) {
        var id = trigger.getAttribute("data-megamenu-trigger");
        MenuTriggers[id] = new MenuTrigger(trigger);
      });
    };

    init = function () {
      createInstances();
    };

    init();

    return {
      MenuTriggers,
    };
  })();
}

/*
if (typeof WDN.CollectionShowcase === "undefined") {
  WDN.CollectionShowcase = (function () {
    var init, createInstances, CollectionLink;

    var nodes = {
      links: document.querySelectorAll("[data-showcase-link]"),
    };

    var list = {};

    var config = {
      link_active_class: "showcase--active",
      showcase_hidden_class: "showcase--hidden",
    };

    CollectionLink = function (link) {
      this.handle = link.getAttribute("data-showcase-link");
      this.link = link;
      this.megamenu_handle = link.getAttribute("data-megamenu-parent");
    };

    CollectionLink.prototype.assign_nodes = function () {
      this.megamenu_parent = document.querySelector("[data-megamenu-group='" + this.megamenu_handle + "']");

      // showcases related to collection link
      this.showcases = document.querySelectorAll("[data-showcase-group='" + this.handle + "']");
      // all showcases in the megamenu
      this.megamenu_showcases = this.megamenu_parent.querySelectorAll("[data-showcase-group]");
    };

    CollectionLink.prototype.set_active = function () {
      this.link.classList.add(config.link_active_class);
      this.showcases.forEach(function (showcase) {
        showcase.classList.remove(config.showcase_hidden_class);
      });
    };

    CollectionLink.prototype.hide_showcases = function () {
      this.megamenu_showcases.forEach(function (showcase) {
        showcase.classList.add(config.showcase_hidden_class);
      });

      nodes.links.forEach(function (link) {
        link.classList.remove(config.link_active_class);
      });
    };

    CollectionLink.prototype.handle_mouseover = function () {
      this.hide_showcases();
      this.set_active();
    };

    CollectionLink.prototype.bind = function () {
      this.link.addEventListener("mouseover", this.handle_mouseover.bind(this));
    };

    CollectionLink.prototype.init = function () {
      this.assign_nodes();
      if (this.showcases.length === 0) return;
      this.bind();
    };

    createInstances = function () {
      nodes.links.forEach(function (link) {
        var collection_handle = link.getAttribute("data-showcase-link");

        list[collection_handle] = new CollectionLink(link);
      });
    };

    init = function () {
      createInstances();
    };

    init();

    return {
      init,
      list,
    };
  })();
}
*/
